export const loader = {
  add: (): void => {
    const loaderOverlay: HTMLElement = document.createElement("div")
    loaderOverlay.classList.add('start-loader-overlay')
    document.body.append(loaderOverlay)
    const loader: HTMLElement = document.createElement('div')
    loader.classList.add('start-loader')
    loaderOverlay.appendChild(loader)
  },
  remove: (): void => {
    const loaderOverlay: HTMLElement | null = document.body.querySelector('.start-loader-overlay')
    if (loaderOverlay !== null) loaderOverlay.remove()
    else throw new Error('Unable to remove loader node from DOM: node not found')
  }
}
